export function getFileExtension(name) {
    return name.replace(/^.*\./, '').toLowerCase();
}
//# sourceMappingURL=getFileExtension.js.map